import { SIDE_NAV_WIDTH_COLLAPSED_PX } from "globalStylesVariables";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  button: {
    "color": "var(--sidebar-foreground)",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "color-mix(in srgb, transparent, var(--sidebar-foreground) 10%)",
    },
    "&:active": {
      backgroundColor: "var(--sidebar-primary)",
    },
    "backgroundColor": "transparent",
  },
  section: {
    justifyItems: "flex-start",
    alignItems: "center",
    width: `${SIDE_NAV_WIDTH_COLLAPSED_PX}px`,
    display: "flex",
    flexDirection: "column",
    paddingBottom: "20px",
  },
});
